import styled from 'styled-components';

export const Container = styled.div`
  display: ${props => props.visible ? 'flex' : 'none'};
  flex: 1;
  flex-direction: column;
  margin: 10px 0 20px;

  @media (min-width: 768px) {
    align-items: flex-start;
  }
`;

export const Label = styled.label`
  font-size: 16px;
  margin-right: 10px;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const InputAndColorBoxWrapper = styled.div`
  display: flex;
`;

export const InputField = styled.input`
  font-size: 16px;
  padding: 10px;
  margin-right: 10px;
  height: 50px;
  box-sizing: border-box;
`;

export const WarningText = styled.p`
  display: flex;
  flex: 1;
  margin-top: 10px;
  align-items: center;
  font-size: 16px;
  margin-top: 15px;

  & svg {
    padding-right: 15px;
    font-size: 40px;
  }
`;

export const ColorBox = styled.span`
  display: inline-flex;
  background-color: ${props => props.color};
  width: 50px;
  height: 50px;
`;